import React from 'react';
import './FieldsOfKnowledge.css';

interface FieldsOfKnowledgeProps {
  doctorName: string;
  timeFrame?: '1 week' | '1 month' | '2 months' | '6 months' | string;
}

// Map global timeframe format to image filename format
const timeframeToImageFormat: { [key: string]: string } = {
  '1 week': 'month',
  '1 month': '3month',
  '2 months': '6month',
  '6 months': 'year',
};

const FieldsOfKnowledge: React.FC<FieldsOfKnowledgeProps> = ({ doctorName, timeFrame = '1 month' }) => {
  // Extract just the first name from the full doctor name
  const firstName = doctorName.split(' ')[1];
  
  // Convert timeframe to image format
  const imageTimeFrame = timeframeToImageFormat[timeFrame] || timeFrame.replace(' ', '');
  
  const imagePath = `/plots/fields_of_knowledge/field_knowledge_${firstName}_${imageTimeFrame}.png`;

  return (
    <div className="fields-of-knowledge">
      <div className="chart-container">
        <img 
          src={imagePath}
          alt={`${doctorName}'s Fields of Knowledge`}
          className="knowledge-plot"
        />
      </div>
    </div>
  );
};

export default FieldsOfKnowledge;
